import React, { useState } from "react";

import { useSetRecoilState } from "recoil";
import {
  customToastState,
  errorToastState,
  modalState,
} from "lib/store/common";
import { changePassword } from "lib/store/user";

import { Button, Input, Modal } from "@atsent/components";

import "./ChangePassword.scss";

export const ChangePassword: React.FC = () => {
  const setModal = useSetRecoilState(modalState);
  const setError = useSetRecoilState(errorToastState);
  const setToast = useSetRecoilState(customToastState);

  const [pw, setPw] = useState({
    old_password: "",
    new_password1: "",
    new_password2: "",
  });

  const handleClickButton = async () => {
    try {
      await changePassword(pw);
      await setToast({
        type: "success",
        text: "비밀번호가 변경되었습니다.",
      });
      await setModal((_) => ({ ..._, myAccount: true, changePassword: false }));
    } catch (e) {
      setError(e);
    }
  };

  return (
    <Modal
      title={"비밀번호 변경"}
      close={() =>
        setModal((_) => ({ ..._, myAccount: true, changePassword: false }))
      }
      cx={`ChangePassword`}
    >
      <Input
        label={"현재 비밀번호"}
        type={"password"}
        handleOnChange={(e) =>
          setPw((_) => ({ ..._, old_password: e.target.value }))
        }
      />
      <Input
        label={"새 비밀번호"}
        type={"password"}
        handleOnChange={(e) =>
          setPw((_) => ({ ..._, new_password1: e.target.value }))
        }
      />
      <Input
        label={"새 비밀번호 확인"}
        type={"password"}
        handleOnChange={(e) =>
          setPw((_) => ({ ..._, new_password2: e.target.value }))
        }
      />
      <div className="button-wrapper">
        <Button cx={"center"} click={() => handleClickButton()}>
          저장
        </Button>
      </div>
    </Modal>
  );
};
